// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__1e5ke","value":"styles_value__1rlTN"};